import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import ProfileCard, { ProfileCardHeader } from "components/profile/profile-card";
import type { CompanyProfile } from "types/api/company/details/overview";
import useUser from "hooks/use-user";

const MapboxMap = dynamic(() => import("components/profile/mapbox-map"));

interface CompanyHqCardProps {
  isLoaded: boolean;
  hasOverviewMap: boolean;
  companyProfile: CompanyProfile;
}

const CompanyHqCard = ({ isLoaded, hasOverviewMap, companyProfile }: CompanyHqCardProps) => {
  const user = useUser();
  const router = useRouter();

  const handleClick = (e: React.MouseEvent | React.KeyboardEvent) => {
    e.preventDefault();
    const redirectUrl = router.asPath;

    if (user?.isLoggedIn && user?.access?.group !== "free") {return;}

    if (!user?.isLoggedIn) {
      router.push(`/signup?redirect=${encodeURIComponent(redirectUrl)}`);
      return;
    }

    if (user?.access?.group === "free") {
      router.push("/upgrade");
    }
  };

  return (
    <ProfileCard>
      <ProfileCardHeader>Company HQ</ProfileCardHeader>

      {isLoaded && hasOverviewMap ? (
        <MapboxMap
          address={[
            companyProfile?.headquartersAddr1,
            companyProfile?.headquartersAddrCity,
            companyProfile?.headquartersAddrStateCode,
            companyProfile?.headquartersAddrZipCode,
          ]}
        />
      ) : (
        <button
          type="button"
          onClick={handleClick}
          onKeyDown={(e) => e.key === "Enter" || e.key === " " ? handleClick(e) : null}
          style={{
            background: "none",
            border: "none",
            padding: 0,
            cursor: "pointer",
          }}
          aria-label="Sign up or upgrade to unlock the HQ map"
        >
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src="/images/map-placeholder.png"
            alt="Company HQ map placeholder"
            style={{ filter: "blur(2px)" }}
          />
        </button>
      )}
    </ProfileCard>
  );
};

export default CompanyHqCard;
